import React from 'react';
import './../../index.css';
import './../../App.scss';
import {
  DefaultBackgroundImage,
  HeaderContainer,
  Message,
  ModalContainer,
  ModalContent,
  ModalMainBodyStyle,
  SocialModalStyle,
  Title,
  HeaderContnet,
  HeaderItem,
  NeedsHelpText,
} from './styledComponents';
import Modal from '../../components/JSModal';
import { getText, TEXT_KEY } from 'shared/utils/localization';
import { onPressHelp } from 'shared/utils/redirectionHelp';
export default function GeoBlock({ status, message }) {
  return (
    <>
      <DefaultBackgroundImage alt="background" src={require(asset`images/Start/Splash_BG@3x.jpg`)} />
      <Modal
        customBackground
        hideCloseButton={true}
        hideOverlay={false}
        isVisible={status === 1}
        modalMainBodyStyle={ModalMainBodyStyle}
        onBackButtonPress={() => null}
        style={SocialModalStyle}
        zIndex={99999}
      >
        <ModalContainer>
          <HeaderContainer
            ibw={require(asset`Full_Modal_Header.ibw`)}
            position="absolute"
            source={require(asset`Full_Modal_Header.png`)}
          >
            <HeaderContnet>
              <HeaderItem />
              <HeaderItem>
                <Title>{getText(TEXT_KEY.GEO_CHECK_ERROR_TITLE)}</Title>
              </HeaderItem>
              <HeaderItem justify={'flex-end'}>
                <NeedsHelpText onClick={onPressHelp}>{getText(TEXT_KEY.NEED_HELP)}</NeedsHelpText>
              </HeaderItem>
            </HeaderContnet>
          </HeaderContainer>
          <ModalContent withButton={false}>
            <Message>{message}</Message>
          </ModalContent>
        </ModalContainer>
      </Modal>
    </>
  );
}
